export const DATA_TEST_IDS = { TITLE: 'video_media_title' };
export const TITLE_SELECTOR = `[data-testid="${DATA_TEST_IDS.TITLE}"]`;
export const TITLE_HINT_OFFSET: [number, number] = [10, 10];
